// Auto-generated by scripts/write-build-metadata.mjs. Do not edit manually.
export const buildMetadata = Object.freeze({
    revision: "eca7e3dccc5d1fe91039369c4a8ec34f8dcb17d7",
});
